import httpClient, { PROJECT_HEADER } from '@xver/libs/axios';

import {
    AttachBlockVolumeRequest,
    BlockVolume,
    CreateBlockVolumeRequest,
    ListBlockVolumesParams,
    ListBlockVolumesResponse,
    UpdateBlockVolumeRequest,
} from './model';

const ENDPOINTS = {
    LIST: '/v1/block-storage/volumes',
    ONE: (id: string) => `/v1/block-storage/volumes/${id}`,
    ATTACH: (id: string) => `/v1/block-storage/volumes/${id}/attach`,
    DETACH: (id: string) => `/v1/block-storage/volumes/${id}/detach`,
};

/** Scoped to `projectId` when given, else to the active project. */
export function listVolumes(
    params?: ListBlockVolumesParams,
    projectId?: string
): Promise<ListBlockVolumesResponse> {
    return httpClient.get(ENDPOINTS.LIST, {
        params,
        headers: projectId ? { [PROJECT_HEADER]: projectId } : undefined,
    });
}

export function getVolume(id: string): Promise<BlockVolume> {
    return httpClient.get(ENDPOINTS.ONE(id));
}

/** Created in the active project; responds 202 with status `creating`. */
export function createVolume(data: CreateBlockVolumeRequest): Promise<BlockVolume> {
    return httpClient.post(ENDPOINTS.LIST, data);
}

export function updateVolume(id: string, data: UpdateBlockVolumeRequest): Promise<BlockVolume> {
    return httpClient.patch(ENDPOINTS.ONE(id), data);
}

/** Only from `available`; responds 202 with status `deleting`. */
export function deleteVolume(id: string): Promise<BlockVolume> {
    return httpClient.delete(ENDPOINTS.ONE(id));
}

export function attachVolume(id: string, data: AttachBlockVolumeRequest): Promise<BlockVolume> {
    return httpClient.post(ENDPOINTS.ATTACH(id), data);
}

export function detachVolume(id: string): Promise<BlockVolume> {
    return httpClient.post(ENDPOINTS.DETACH(id), {});
}
